import { c as _c } from "react/compiler-runtime";
import request, { getErrorMessage } from '@onefootprint/request';
import { useToast } from '@onefootprint/ui';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import type { AuthHeaders } from '@/hooks/use-session';
import useSession from '@/hooks/use-session';
const removeRoleRequest = async (authHeaders: AuthHeaders, id: string) => {
  const {
    data
  } = await request({
    method: 'POST',
    url: `/org/roles/${id}/deactivate`,
    headers: authHeaders
  });
  return data;
};
const useRemoveRole = name => {
  const $ = _c(15);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "pages.members.roles.remove"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("settings", t0);
  const {
    toast
  } = useToast();
  const session = useSession();
  const queryClient = useQueryClient();
  let t1;
  if ($[1] !== session) {
    t1 = id => removeRoleRequest(session.authHeaders, id);
    $[1] = session;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t || $[4] !== toast) {
    t2 = error => {
      toast({
        description: getErrorMessage(error),
        title: t(_temp),
        variant: "error"
      });
    };
    $[3] = t;
    $[4] = toast;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== name || $[7] !== queryClient || $[8] !== t || $[9] !== toast) {
    t3 = () => {
      toast({
        description: t(_temp2, {
          name
        }),
        title: t(_temp3)
      });
      queryClient.invalidateQueries();
    };
    $[6] = name;
    $[7] = queryClient;
    $[8] = t;
    $[9] = toast;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== t3) {
    t4 = {
      mutationFn: t1,
      onError: t2,
      onSuccess: t3
    };
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return useMutation(t4);
};
export default useRemoveRole;
function _temp($) {
  return $.feedback.error.title;
}
function _temp2($_0) {
  return $_0.feedback.success.description;
}
function _temp3($_1) {
  return $_1.feedback.success.title;
}